// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"calculator"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M4 22H20V8H4V22Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M20 2H4V8H20V2Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M20 8V2H4V8M20 8H4M20 8V22H4V8","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M8 13H10M14 13H16M14 17H16M8 17H10","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const CalculatorIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'calculator',
    ref,
    icon: element,
  },
));

CalculatorIcon.displayName = 'CalculatorIcon';

export default CalculatorIcon;
